import axios from "axios";
import environment from "@/environment";

const api = axios.create({ baseURL: `${environment.API}/machine` });

export const machineService = {
	checkMachineStatus: () => api.get("/status")
};

export const machineList = {
	checkMachineList: () => api.get("/list-machines")
};


export async function FetchMachineDashboard () {

	try {
		const response = await machineService.checkMachineStatus();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response) {
			return {
				statusCode: error.response.status,
				problems: error.response.data.problems
			};
		}
		else {
			return {
				statusCode: 500,
				problems: ["Falha crítica de conexão"]
			};
		}
	}
}



export async function FetchMachineList () {

	try {
		const response = await machineList.checkMachineList();
		return { listaPrensa: response.data };
	}
	catch (error) {
		if (error.response) {
			return {
				listaPrensa: error.response.data
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}
}